const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const WHITESPACE_PATTERN = /\s/;

export const validateAdminUserCreateForm = (formData) => {
  if (!formData.cognitoUsername) {
    return "ログインIDを入力してください。";
  }
  if (formData.cognitoUsername.length > 128) {
    return "ログインIDは128文字以内で入力してください。";
  }
  if (WHITESPACE_PATTERN.test(formData.cognitoUsername)) {
    return "ログインIDに空白文字は使用できません。";
  }

  const email = formData.email.trim();
  if (!email) {
    return "メールアドレスを入力してください。";
  }
  if (!EMAIL_PATTERN.test(email)) {
    return "メールアドレスの形式が正しくありません。";
  }
  if (!formData.adminUserName.trim()) {
    return "氏名を入力してください。";
  }
  if (formData.role !== "admin" && formData.role !== "super_admin") {
    return "権限を選択してください。";
  }
  if (
    formData.role === "admin" &&
    (formData.companyId === "" || formData.companyId == null)
  ) {
    return "admin の場合は会社を選択してください。";
  }

  return "";
};

// 登録APIに送信してよい5項目だけを組み立てる。
export const buildAdminUserCreatePayload = (formData) => ({
  cognito_username: formData.cognitoUsername,
  email: formData.email.trim(),
  admin_user_name: formData.adminUserName.trim(),
  role: formData.role,
  company_id:
    formData.role === "super_admin" ? null : Number(formData.companyId),
});

export const generateIdempotencyKey = () => {
  if (typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
    .slice(6, 8)
    .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
};

export const isAdminUserCreateRetryable = (status) =>
  status === 0 || status === 202 || status === 429 || status >= 500;
